module.exports = __webpack_public_path__ + "img/POP-00009-3.cc45c735.png";